import {get,post} from '../common/axios'

//用户【登录】行为记录
export const addLoginBehaviorApi = p => post('/main/behavior/login', p);
//用户【阅读】行为记录
export const addAppreciateDocumentBehaviorApi = p => post('/main/behavior/appreciateDocument', p);



// WEBPACK FOOTER //
// ./src/service/behavior.js